﻿export interface ISessionStoreCache {
    expires: Date;
    values: string[];
}

export class SessionStoreCache implements ISessionStoreCache {
    expires: Date;
    values: string[];

    constructor(values: string[], expiresInMinutes: number = 60) {
        const expireTime = new Date();
        expireTime.setMinutes(expireTime.getMinutes() + expiresInMinutes);
        this.expires = new Date(expireTime);
        this.values = values;
    }

    get isExpired() {
        return this.expires < new Date();
    }

    static fromObject(obj: ISessionStoreCache): SessionStoreCache | null {
        if (!(Array.isArray(obj.values))) {
            return null;
        }

        const c = new SessionStoreCache(obj.values);
        c.expires = new Date(obj.expires);
        return c;
    }

    static readFromSessionStorage(sessionStoreKey: string): SessionStoreCache | null {
        const sessionGroups = sessionStorage.getItem(sessionStoreKey);
        if (!sessionGroups) {
            return null;
        }

        const parsedGroups = JSON.parse(sessionGroups) as ISessionStoreCache;

        return this.fromObject(parsedGroups);
    }

    writeToSessionStorage(sessionStoreKey: string) {
        sessionStorage.setItem(sessionStoreKey, JSON.stringify(this));
    }
}
